import NoData from "@/components/NoData";
import LtdLoading from "@/components/LichThiDauFull/LtdLoading";
import LeagueSelect from "@/components/LichThiDauByLeagueSidebar/LeagueSelect";
import useBangXepHangByLeague from "@/components/BangXepHangByLeague/useBangXepHangByLeague";
import LeagueStandingSidebar from "./LeagueStandingSidebar";
import "@/components/LichThiDauFull/index.css";
import "@/components/LichThiDauByLeagueSidebar/index.css";
import "./index.css";

/**
 * @param {object} props
 * @param {string} props.league
 */
export default function BangXepHangByLeagueSidebar({ league: leagueSlug }) {
  const {
    themeStyle,
    activeSlug,
    setActiveSlug,
    league,
    standingsRes,
    waiting,
    failed,
  } = useBangXepHangByLeague(leagueSlug);

  const totalStandings = standingsRes?.totalStandings || [];
  const colorInfos = standingsRes?.colorInfos || [];
  const hasContent = totalStandings.length > 0;

  return (
    <div
      className="kbv-ltd-full kbv-ltd-sb kbv-bxh-sb text-[var(--theme-text)]"
      style={themeStyle}
    >
      <div className="kbv-ltd-sb-filters">
        <LeagueSelect
          selectedSlug={activeSlug}
          currentLeague={league}
          onSelect={setActiveSlug}
          themeStyle={themeStyle}
        />
      </div>
      {failed ? (
        <NoData message="Không có bảng xếp hạng" />
      ) : !activeSlug || waiting ? (
        <LtdLoading compact />
      ) : !hasContent ? (
        <NoData message="Không có bảng xếp hạng" />
      ) : (
        <div className="kbv-bxh-sb-body">
          <LeagueStandingSidebar
            key={league.id}
            standings={totalStandings}
            colorInfos={colorInfos}
          />
        </div>
      )}
    </div>
  );
}
